import React, {useEffect, useState} from "react";
import {Alert, Dialog, DialogActions, DialogContent, DialogTitle, Grid2} from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import useDataPost from "../../../../../hooks/useDataPost";
import CustomTextField from "../../../../../components/customMUIComponents/CustomTextField";

interface UpdatePasswordModalProps {
    open: boolean,
    setOpen: (open: boolean) => void,
    email?: string,
}

const UpdatePasswordModal = ({open, setOpen, email}: UpdatePasswordModalProps) => {

    const [error, setError] = useState<string>();
    const [emailField, setEmailField] = useState<string>(email || '');

    const {postDataPromise} = useDataPost<void>(`/update-password`, {}, true, false, false);

    const handleCloseModal = () => {
        setOpen(false);
    }

    useEffect(() => {
        if (email) {
            setEmailField(email);
        }
    }, [email]);

    const handleUpdate = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');
        postDataPromise(undefined, {
            email: email,
        }).then((response) => {
            window.location.href = window.location.href + '?passwordUpdated=true';
        }).catch((reason) => {
            setError("Une erreur s'est produite. Veuillez réessayer.")
        })
    }

    return (
        <>
            <form onSubmit={(e) => handleUpdate(e)}>
                <Dialog
                    disablePortal
                    open={open}
                    onClose={() => setOpen(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <DialogTitle>
                        <Typography variant={"secondVariant"} fontSize={{xs: 18, sm: 20, md: 22}}>
                            Réinitialisation du mot de passe
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{
                        minWidth: '300px'
                    }}>
                        <Grid2 container>
                            <Grid2 size={12}>
                                <Typography
                                    variant={"secondVariant"}
                                >
                                    Un lien de réinitialisation vous sera envoyé par mail.
                                </Typography>
                            </Grid2>
                            <Grid2 size={12} mt={2}>
                                <CustomTextField
                                    value={emailField}
                                    label="Adresse email"
                                    mb={4}
                                    type="text"
                                    required
                                    setField={setEmailField}
                                    variant="outlined"
                                    disabled={!!email}
                                />
                            </Grid2>
                        </Grid2>
                        {error && (
                            <Alert
                                severity="error"
                                sx={{mb: 4}}
                            >
                                {error}
                            </Alert>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            type={"submit"}
                        >
                            Envoyer l'email
                        </Button>
                        <Button onClick={() => handleCloseModal()}>Fermer</Button>
                    </DialogActions>
                </Dialog>
            </form>
        </>
    );
}

export default UpdatePasswordModal